/**
 * Verified business data used in structured data (JSON-LD) across the site.
 * Every field here is sourced from content already present in the project:
 *   - phone/email: src/components/ContactInfo.tsx
 *   - "24/7" claim: src/contacts/contact.tsx ("Call Us 24/7" / "available247")
 *   - country: the site consistently describes itself as Oman-based throughout
 *
 * Deliberately NOT included because no confirmed value exists anywhere in
 * the project: street address, postal code, city/locality, sameAs (social
 * links) — see the Phase 3 report for why (src/components/Social.tsx only
 * has placeholder/broken URLs, not real company profiles).
 */
export const BUSINESS = {
  name: "SilverJarz",
  legalName: "SilverJarz Travel & Tourism",
  url: "https://silverjarz.com",
  logo: "https://silverjarz.com/img/logo.png",
  telephone: "+968 93579571",
  email: "info@silverjarz.com",
  addressCountry: "OM",
} as const;

export function organizationJsonLd() {
  return {
    "@context": "https://schema.org",
    "@type": "TravelAgency",
    name: BUSINESS.name,
    legalName: BUSINESS.legalName,
    url: BUSINESS.url,
    logo: BUSINESS.logo,
    telephone: BUSINESS.telephone,
    email: BUSINESS.email,
    address: {
      "@type": "PostalAddress",
      addressCountry: BUSINESS.addressCountry,
    },
    areaServed: "OM",
  };
}

export function breadcrumbJsonLd(items: { name: string; url: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((item, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function faqJsonLd(faqs: { question: string; answer: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.question,
      acceptedAnswer: {
        "@type": "Answer",
        text: f.answer,
      },
    })),
  };
}
